import { createContext } from "react"

export const AiContext = createContext(null)
